import axios from 'axios';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import Topnav from '../../components/adminNav/Topnav';
import Sidebar from '../../components/sidebar/Sidebar';
import { BASE_URL } from '../../requestMethod';

// https://elo.projectdriveng.com.ng/api/Order/vendorareas?VendorId=e47a33dc-69f8-454e-9eae-3b0925365b7e

const Settings = () => {
    const [price, setPrice] = useState("");
    const [area, setArea] = useState("");
    const [appMode, setAppMode] = useState("");
    const [areaList, setAreaList] = useState([]);
    const [loading, setLoading] = useState("")
    const user = useSelector((state) => state.user.currentUser);
    useEffect(() => {
        getVendorArea()
        getAppMode()

        //console.log(appMode)
    }, [])
      
    const getVendorArea = async() =>{
        const listResult = await axios.get(`${BASE_URL}Order/vendorareas?VendorId=${user.returnObj.vendorId}`)
        //console.log(listResult.data)
        setAreaList(listResult.data.returnObj)
    }
    const getAppMode = async() =>{
        const listResult = await axios.get(`${BASE_URL}Vendor/CheckAppMode?VendorId=${user.returnObj.vendorId}`)
        //console.log(listResult.data)
        setAppMode(listResult.data.returnObj.appMode)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading("Posting Area...")
        const mprice = parseInt(price);
        const model = {
            deliveryPrice: mprice, area, vendorId: user.returnObj.vendorId
        }
        try {
            const res = await axios.post(`${BASE_URL}Settings/addHomeDelivery`, model, {
                mode: 'no-cors',
                headers: { 'Authorization': `Bearer ${user.returnObj.token}` }
            });
            console.log(model);
           // console.log(res.data);
           setLoading("")
            getVendorArea()
            if (res.data.status) {
                Swal.fire({
                    title: 'Success',
                    text: res.data.response,
                    icon: 'success',
                    confirmButtonText: 'Thanks'
                });
                //toast.success(res.data.response)
                //window.location.replace("/products");
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.response,
                    icon: 'error',
                    confirmButtonText: 'Cancel'
                });

            }
        }
        catch (err) {
            console.log(err)
            setLoading("Error occured...", err)
        }
    }

    const handleChangeMode = async () => {
          try {
            const res = await axios.get(`${BASE_URL}Vendor/switchmode?vendorId=${user.returnObj.vendorId}`);
            console.log(res);
            if(res.data.returnObj.appMode){ 
                setAppMode("live")
            }
            else{
                setAppMode("test")   
            }
               // console.log(res.data); 
            } catch (error) {
                console.log(error)
        }
    }
const [editMode, setEditMode] = useState(false)
const [selectedArea, setSelectedArea] = useState({})
    const handleEdit = (item) => {
        setEditMode(true);
        setSelectedArea(item)
        //console.log(item)
    }
    const handleUpdate = async () => {
        //Settings/editArea
        setLoading("Updating Area...")
        const mprice = price? parseInt(price): selectedArea.deliveryPrice;
        const model = {
           id:selectedArea.id, deliveryPrice: mprice, area: area ? area : selectedArea.area, vendorId: selectedArea.vendorID
        }
        //console.log(model)
        
            await axios.post(`${BASE_URL}Settings/editArea`, model, {
                mode: 'no-cors',
                headers: { 'Authorization': `Bearer ${user.returnObj.token}` }
            }).then((res) => {
                    console.log(res.data);
            setLoading("")
                getVendorArea()
                if (res.data.status) {
                    Swal.fire({
                        title: 'Success',
                        text: res.data.response,
                        icon: 'success',
                        confirmButtonText: 'Thanks'
                    });
                    //toast.success(res.data.response)
                    window.location.reload();
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.response,
                        icon: 'error',
                        confirmButtonText: 'Cancel'
                    });

                }
            }).catch((err) => {
                setPrice("");
                    setArea("");
                    setEditMode(false);
                    console.log(err)
                    setLoading("Error occured...", err)
            })
        
        
    }
    return (
        <div className="container-scroller">
            <Topnav />
            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="content-wrapper">
                    <div className="page-header">
                        <h3 className="page-title"> Settings
                        </h3>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                {/* <li className="breadcrumb-item"><a href="/createProduct" class="btn btn-gradient-success btn-fw">Add Product</a></li> */}
                            </ol>
                        </nav>
                    </div>

                    <div className="row">
                        <div className="col-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">Recent Updates</h4>
                                    <div className="">
                                        <div className="">
                                            {/* <i className="mdi mdi-account-outline icon-sm me-2" /> */}
                                            <div className="row">
                                                <div className="col-md-6 col-sm-12">
                                                    <span>Have control of app mode</span>
                                                </div>
                                                <div className="col-md-6 col-sm-12">
                                                {appMode==="test" ? 
                                                (<button className='btn btn-success' onClick={handleChangeMode}>Go Live</button>):
                                                (<button className='btn btn-danger' onClick={handleChangeMode}>Test Mode</button>)}
                                                </div>
                                            </div>
                                            
                                            
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* add location area */}
                    <div className="row">
                        <div className="col-md-7 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title text-white">Delivery Price</h4>
                                    {loading && (<p style={{color:'red'}}>{loading}</p>)}
                                    
                                    {!editMode ? (
                                        <div className="">
                                        <input type="text" className="form-control mb-2" onChange={(e) => setArea(e.target.value)} placeholder="Add Area" />
                                        <input type="text" className="form-control" onChange={(e) => setPrice(e.target.value)} placeholder="Add delvery price of your area now" />
                                        <button className="add btn btn-gradient-primary font-weight-bold" id="add-task" onClick={handleSubmit}>Add</button>
                                    </div>
                                    ): (
                                        <div className="">
                                        <input type="text" className="form-control mb-2" onChange={(e) => setArea(e.target.value)} defaultValue={selectedArea.area} />
                                        <input type="text" className="form-control" onChange={(e) => setPrice(e.target.value)} defaultValue={selectedArea.deliveryPrice} />
                                        <button className="add btn btn-gradient-primary font-weight-bold" id="add-task" onClick={handleUpdate}>Update</button>
                                    </div>
                                    )}

                                    <div className="list-wrapper">
                                        <hr />
                                        {/* <ul className="d-flex flex-column-reverse todo-list todo-list-custom"> */}
                                        <div>
                                            {
                                                areaList.map((e, index)=> (
                                                    <div className='row' key={index}>
                                                        {/* <div className='table-responsive'> */}
                                                            <div className='col-5'>
                                                                {e.area}
                                                            </div>
                                                            <div className='col-5'>
                                                                NGN {e.deliveryPrice}
                                                            </div>
                                                            <div className='col-2'>
                                                                <span className='text-danger' style={{cursor:'pointer'}} onClick={()=>handleEdit(e)}>Edit</span>
                                                            </div>
                                                        {/* </div>  */}
                                                        <hr />
                                                    </div>
                                                ))
                                            }
                                        {/* </ul> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Settings;
